import React, { MutableRefObject } from "react";

export const ImageCacheContext = React.createContext<MutableRefObject<Map<string, string>>>(undefined as any);
